import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RegisterForm } from '@/components/auth/RegisterForm';
import { useAuth } from '@/hooks/useAuth';
import { Link } from 'react-router-dom';

const Register = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (user && !loading) {
      navigate('/');
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#B8860B]"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-black">
      {/* Left Side - Branding */}
      <div className="hidden md:flex md:w-1/2 bg-gradient-to-br from-black via-neutral-900 to-black items-center justify-center p-12 relative overflow-hidden">
        {/* Decorative gold accent */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#B8860B]/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#D4AF37]/10 rounded-full blur-3xl" />

        <div className="space-y-8 text-center relative z-10">
          <Link to="/" className="flex items-center justify-center">
            <span className="text-4xl font-bold tracking-tight">
              <span className="text-[#B8860B]">Beauty</span>
              <span className="text-[#D4AF37]">Book</span>
              <span className="text-[#B8860B] text-3xl">AI</span>
            </span>
          </Link>
          <p className="text-xl text-white/80 max-w-md leading-relaxed">
            {t('register.brandSubtitle')}
          </p>
          <div className="flex justify-center gap-2 pt-4">
            <div className="w-2 h-2 rounded-full bg-[#B8860B]" />
            <div className="w-2 h-2 rounded-full bg-[#D4AF37]" />
            <div className="w-2 h-2 rounded-full bg-[#B8860B]" />
          </div>
        </div>
      </div>

      {/* Right Side - Form */}
      <div className="flex-1 flex items-center justify-center p-6 md:p-12 bg-gradient-to-br from-[#0a0a0a] to-[#111111] relative overflow-hidden">
        {/* Decorative elements for mobile */}
        <div className="absolute top-0 left-0 w-64 h-64 bg-[#B8860B]/5 rounded-full blur-3xl md:hidden" />
        <div className="absolute bottom-0 right-0 w-48 h-48 bg-[#D4AF37]/5 rounded-full blur-3xl md:hidden" />

        {/* Mobile logo */}
        <div className="absolute top-8 left-1/2 -translate-x-1/2 md:hidden">
          <Link to="/" className="flex items-center justify-center">
            <span className="text-2xl font-bold tracking-tight">
              <span className="text-[#B8860B]">Beauty</span>
              <span className="text-[#D4AF37]">Book</span>
              <span className="text-[#B8860B] text-xl">AI</span>
            </span>
          </Link>
        </div>

        <div className="relative z-10 w-full max-w-md mt-16 md:mt-0">
          <RegisterForm />
        </div>
      </div>
    </div>
  );
};

export default Register;
